<template>
  <div>
    <a
      class="nav-item nav-link h-100"
      @click.prevent="setParentActive"
      :id="`panel-${tierid}-tab`"
      data-toggle="pill"
      :data-tier="`${tiercode}`"
      :href="`panel-${tierid}`"
      role="tab"
      :aria-controls="`panel-${tierid}`"
      :class="{ active: $parent.isActive(String(tierid)) }"
      :aria-selected="[$parent.isActive(String(tierid)) ? true : false]"
      :tabindex="[$parent.isActive(String(tierid)) ? 0 : -1]"
      :data-tier-id="`${tierid}`"
    >
      <slot></slot>
    </a>
  </div>
</template>

<script>
export default {
  name: "selector-tab",
  props: {
    tierid: "",
    tiercode: "",
  },
  methods: {
    setParentActive() {
      this.$parent.setActive(String(this.tierid), String(this.tiercode));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/components/member-tier-selector-tab.vue